import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { UserContext } from '../context';


function AnchorRoute({ component: Component, ...rest }) {
  return (
    <UserContext.Consumer>
      {(value) => (<Route
        {...rest}
        render={(props) =>
          (value.authenticated && value.user.account.anchor) ? (
            <Component {...props} user={value} />
          ) : (
            <Redirect
              to={{
                pathname: '/',
                state: { from: props.location },
              }}
            />
          )
        }
                   />)}
    </UserContext.Consumer>
  );
}

export default AnchorRoute;
